import qs from "qs";

import { ApiService } from "services/Api.service";

import {
  Query as TableQuery,
  QueryResult as TableQueryResult
} from "components/common/table/types";
import { tableConstructQueryParams } from "utils/query/tableConstructQueryParams";
import { Job, JobDto } from "models/job/Job";

export class JobService {
  private _apiService: ApiService;

  constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  public async fetchJob({ id }: { id: number }) {
    const response = await this._apiService.get(`/overmind/job/${id}`);

    return Job.create(response);
  }

  public async fetchJobChildren({ id }: { id: number }) {
    const response = await this._apiService.get(`/overmind/job/${id}/children`);

    return {
      count: response.count,
      list: response.list.map((child: JobDto) => Job.create(child))
    };
  }

  public async list({
    query
  }: {
    query: TableQuery;
  }): Promise<TableQueryResult<Job>> {
    const queryParams = {
      ...tableConstructQueryParams(query)
    };

    const { count, list } = await this._apiService.get(
      `/overmind/job`,
      {
        searchFields: [],
        ...queryParams
      },
      {
        paramsSerializer: (params: any) => qs.stringify(params)
      }
    );

    return {
      count,
      list: list.map((job: JobDto) => Job.create(job))
    };
  }
}
